export const ApiPaths = {
  LOGIN_URL: "/token",
  Upload: {
    axis: "/misrecon/api/upload/axis",
    bajaj: "/misrecon/api/upload/bajaj",
    hdfc: "/misrecon/api/upload/hdfc",
    icici: "/misrecon/api/upload/icici",
    iifl: "/misrecon/api/upload/iifl",
    kotak: "/misrecon/api/upload/kotak",
    zerodha: "/misrecon/api/upload/zerodha",
    marwadi: "/misrecon/api/upload/marwadi",
    ventura: "/misrecon/api/upload/ventura",
    religare: "/misrecon/api/upload/religare",
  },
  UploadFromAPI: {},
  REPORTS_URL: "/misrecon/api/reports/brokerdata",
  DROPDOWN_DATA_URL: "/misrecon/api/reports/filterdata",
};
